<template lang="pug">
  app-card
    app-card-header 
      v-layout
        v-flex {{ caseItem.status.title }}
        v-flex.text-lg-right {{ caseItem.distribDate ? formatDate(caseItem.distribDate) : formatDate(caseItem.createDate) }}
    app-card-body
      app-card-headline(v-line-clamp="1"  v-html="caseNumber(caseItem)")
      app-card-title.fix-height-catgory(v-line-clamp="2" v-html="caseCategory(caseItem)") 
      app-card-caption 
        span(v-if="caseItem.judge") {{ isNull(caseItem.judge.lastName) + ' ' + isNull(caseItem.judge.firstName) + ' ' + isNull(caseItem.judge.middleName) }}
        span(v-else style="color:red;") Не распределено
</template>

<script>
import moment from 'moment'
moment.locale('ru')

export default {
  props: {
    caseItem: Object,
    search: String
  },

  methods: {
    caseNumber (courtCase) {
      if (!this.search || this.search.length == 0 ) {
        return courtCase.number
      }
      return courtCase.number.replace(new RegExp(this.search, "gi"), match => {
        return `<span style="color: #00BCD4; margin: 0px 1px;">${match}</span>`
      })
    },

    caseCategory (courtCase) {
      let category = courtCase.mainLawArticle ? courtCase.mainLawArticle + ' УК РФ' : courtCase.caseCategory ? courtCase.caseCategory.title : 'Категория не определена'
      if (!this.search || this.search.length == 0 ) return category
      
      return category.replace(new RegExp(this.search, "gi"), match => {
        return `<span style="color: #00BCD4; margin: 0px 1px;">${match}</span>`
      })
    },

    formatDate (date) {
      return moment(date).format("DD.MM.YYYY")
    },

    isNull (text) {
      return text ? text : ''
    },

  }
}
</script>